import { LabelValueSet } from "../utility/LabelValueSet";

const NursingDegreeType = Symbol();

export class NursingDegree extends LabelValueSet  {
    [NursingDegreeType]: any;

    static fromNothing(): NursingDegree {
        return なし;
    }
}

const なし = new NursingDegree("認定なし", "なし");
const 要支援1 = new NursingDegree("要支援1", "要支援1");
const 要支援2 = new NursingDegree("要支援2", "要支援2");
const 要介護1 = new NursingDegree("要介護1", "要介護1");
const 要介護2 = new NursingDegree("要介護2", "要介護2");
const 要介護3 = new NursingDegree("要介護3", "要介護3");
const 要介護4 = new NursingDegree("要介護4", "要介護4");
const 要介護5 = new NursingDegree("要介護5", "要介護5");


const mapValueToItem: { [key: string] : NursingDegree} = {
    "なし": なし,
    "要支援1": 要支援1,
    "要支援2": 要支援2,
    "要介護1": 要介護1,
    "要介護2": 要介護2,
    "要介護3": 要介護3,
    "要介護4": 要介護4,
    "要介護5": 要介護5,
};

export const nursingDegreeList: NursingDegree[] = [
    なし,
    要支援1,
    要支援2,
    要介護1,
    要介護2,
    要介護3,
    要介護4,
    要介護5,
];

export const getNursingDegreeFromValue = (value: string): NursingDegree | undefined => {
    return mapValueToItem[value];
};
